<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <EditInsurance title="กรุณากรอกข้อมูล"></EditInsurance>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditInsurance from "./EditInsurance";
export default {
  name: "customerInsuranceDetail",
  components: {
    EditInsurance,
  },
};
</script>
<style scoped></style>
